import { PowerSyncContext } from '@powersync/react';
import { Navigate, Outlet } from '@tanstack/react-router';

import { t } from '../i18n/es.js';
import { useSession } from '../session.jsx';
import { SyncedTheme } from '../theme/ThemeControl.jsx';

import { DbHandle } from './SidebarFooter.jsx';

/**
 * Frame of the full-screen modes (docs/05 §5.1: triage, and the weekly review in F2): it waits for
 * the session and the local database like `AppLayout`, but without sidebar nor view header. Each
 * mode draws its own way out.
 */
export function FocusLayout() {
  const { status, user, local } = useSession();
  if (status === 'loading') return <p className="muted">{t.app.loading}</p>;
  if (status === 'anonymous' || !user) return <Navigate to="/login" />;
  if (status === 'opening' || !local) return <p className="muted">{t.app.openingDatabase}</p>;

  return (
    <PowerSyncContext.Provider value={local.db}>
      <SyncedTheme userId={user.id} />
      <DbHandle local={local} userId={user.id} />
      <Outlet />
    </PowerSyncContext.Provider>
  );
}
